package fr.frux.feature.treedetail.move

import fr.frux.feature.treedetail.TreeDetail
import fr.frux.feature.treedetail.identity.TreeIdentityController

/** Ce que l'écran de déplacement doit savoir de l'arbre, sans le recharger. */
data class MoveTreeArgs(
    val treeId: Long,
    val latitude: Double,
    val longitude: Double,
    val speciesName: String,
    val scientificName: String,
    val canReportGone: Boolean,
)

internal fun TreeDetail.toMoveTreeArgs() =
    MoveTreeArgs(
        treeId = id,
        latitude = latitude,
        longitude = longitude,
        speciesName = speciesName,
        scientificName = scientificName,
        canReportGone = !isOwnTree && !reportedGoneByMe,
    )

/** Sans compte, l'invite de connexion s'ouvre à la place de l'écran de déplacement. */
internal fun TreeIdentityController.moveOrAskLogin(
    tree: TreeDetail,
    onMoveTree: (MoveTreeArgs) -> Unit,
) {
    if (requestMove()) onMoveTree(tree.toMoveTreeArgs())
}
